export default "__VITE_ASSET__CiEJ5HAM__"